<template>
  <div class="maintain">
    <!--工具条-->
    <div style="margin: 10px 0;">
      <toolbar :buttonList="buttonList_toolBar1" @callFunction="callFunction"></toolbar>
    </div>
    <div>
      <el-table border :data="tableList">
        <el-table-column label="属性名称" prop="propertyName" align="center"></el-table-column>
        <el-table-column label="属性值" align="center">
          <template slot-scope="scope">
            <span v-for="(v, i) in scope.row.propertyValues" :key="i">{{v.propertyValueString}}、</span>
          </template>
        </el-table-column>
        <!-- <el-table-column label="操作" align="center">
          <template slot-scope="scope">
            <el-button size="mini" v-for="(item, index) in buttonList_table" :key="index" :type="item.buttonType" @click="callFunctionRow(item, index, scope.row)">{{item.displayName}}</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>
    <!-- 添加属性 -->
    <el-dialog title="添加属性" :visible.sync="dialogVisible1">
      <div>
        <!-- <el-button type="primary" @click="createProperty">新增属性</el-button> -->
        <toolbar
            :buttonList="buttonList_toolBar2"
            @callFunction="callFunction"
        ></toolbar>
      </div>
      <div>
        <ul>
          <li v-for="(item, index) in propertyList" :key="index">
            <div class="check-all">
              <el-checkbox :indeterminate="item.isIndeterminate" v-model="item.checkAll" @change="(value) => handleCheckAllChange(value, item)">{{item.name}}</el-checkbox>
              <p class="switch" @click="switchBtn(item, index)">
                <i
                  :class="item.isSwitch ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                ></i>
              </p>
            </div>
            <div class="check-item" style="margin: 15px 0;padding-left:20px;" v-show="item.isSwitch">
              <el-button style="margin-bottom:10px" size="mini" type="primary" @click="createPropertyVal(item)">新增属性值</el-button>
              <!-- <toolbar
                  :buttonList="buttonList_toolBar3"
                  @callFunction="callFunction"
              ></toolbar> -->
              <el-checkbox-group v-model="item.checkedCities" @change="(value) => handleCheckedCitiesChange(value, item)">
                <el-checkbox v-for="(val, indx) in item.items" :label="val.id" :key="indx" @change="(value) => handleCheckitem(value, val)">{{val.name}}</el-checkbox>
              </el-checkbox-group>
            </div>
          </li>
        </ul>
      </div>
      <div slot="footer">
        <el-button @click="dialogVisible1 = false">取消</el-button>
        <el-button type="primary" @click="submitProperty">确定</el-button>
      </div>
    </el-dialog>
    <!-- 新增属性 -->
    <el-dialog title="新增属性" :visible.sync="dialogVisibleProperty" width="30%">
      <el-form inline>
        <el-form-item label="属性名称：">
          <el-input v-model="property.name"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addProperty">添加</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 新增属性值 -->
    <el-dialog title="新增属性值" :visible.sync="dialogVisiblePropertyValue" width="30%">
      <el-form inline>
        <el-form-item label="属性值：">
          <el-input v-model="propertyValue.value"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="addPropertyVal">添加</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { getButtonList } from "../../../promissionRouter";
import toolbar from "../../../components/Toolbar";
import {
  UpdateProperties,
  GetAllProperties,
  PropertyValueCreate,
  PropertyValueGetAll,
  PropertyCreate,
  GetAllWithItem
} from '../../../api/api'
export default {
  components: {
    toolbar
  },
  data() {
    return {
      propertyGroupId: null, 
      isIndeterminate: false,
      checkAll: false,
      dialogVisible1: false,
      dialogVisibleProperty: false,
      dialogVisiblePropertyValue: false,
      dialogVisibleAdd: false,
      dialogVisibleEdit: false,
      buttonList_toolBar: [],
      buttonList_toolBar1: [],
      buttonList_toolBar2: [],
      buttonList_toolBar3: [],
      buttonList_table: [],
      valueTime: [],
      total: 0,
      tableList: [],
      property: {
        name: ''
      },
      propertyList: [],
      propertyValue: {
        propertyId: null,
        value: ''
      },
      propertyValueList: [],
      checkList: []
    }
  },
  created() {
    if (this.$route.query.groupId) {
      this.propertyGroupId = JSON.parse(this.$route.query.groupId)
    }
    if (this.groupId) {
      this.propertyGroupId = this.groupId
    }
    this.getTableData()
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    const toolBarButtonList = buttonList.filter((item) => {
      return item.buttonShow === 10;
    });
    this.buttonList_toolBar = toolBarButtonList;
    this.buttonList_toolBar1 = [toolBarButtonList[0]];
    this.buttonList_toolBar2 = [toolBarButtonList[1]];
    this.buttonList_toolBar3 = [toolBarButtonList[2]];

    const tableButtonList = buttonList.filter((item) => {
      return item.buttonShow === 20;
    });
    this.buttonList_table = tableButtonList;
  },
  methods: {
    handleCheckAllChange(val, data) {
      if (!data.items.length) {
        data.checkAll = false
        return this.$message.error('请先获取属性值！')
      }
      data.isChecked = val
      // console.log(val, data)
      let arr = []
      data.items.forEach(item => {
        item.isCheck = val
        arr.push(item.id)
      })
      data.checkedCities = val ? arr : [];
      data.isIndeterminate = false;
    },
    handleCheckedCitiesChange(value,data) {
      // console.log(value, data)
      let checkedCount = value.length;
      data.checkAll = checkedCount === data.items.length;
      data.isIndeterminate = checkedCount > 0 && checkedCount < data.items.length;
    },
    handleCheckitem(val, data) {
      data.isCheck = val
      // console.log(val, data)
    },
    callFunction(item) {
      this[item.buttonFunc](this, item);
    },
    callFunctionRow(item, index, row) {
      this[item.buttonFunc](item, index, row);
    },
    getTableData() {
      GetAllProperties({PropertyGroupId: this.propertyGroupId,ShowAll: true,}).then(res => {
        if (res.data.success) {
          this.tableList = res.data.result.items
          let list = []
          this.tableList.forEach(item => {
            list.push({
              id: item.propertyId,
              checkedCities: item.propertyValues.map(val => {
                return val.propertyValueId
              })
            })
          })
          this.checkList = list
          // console.log(list, 'list')
        }
      })
    },
    addMaintain() {
      this.dialogVisible1 = true
      this.getProperty()
      // console.log(this.tableList, '????')
    },
    createProperty() {
      this.dialogVisibleProperty = true
      // this.getProperty()
    },
    addProperty() {
      PropertyCreate(this.property).then(res => {
        if (res.data.success) {
          this.getProperty()
          this.property.name = ''
          this.dialogVisibleProperty = false
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    getProperty() {
      GetAllWithItem({showAll: true}).then(res => {
        if (res.data.success) {
          let list = res.data.result.items || []
          list.forEach(item => {
            item.isEdit = false
            item.isSwitch = true
            item.checkAll = false
            item.isIndeterminate = false
            item.isChecked = false
            item.checkedCities = []
          });
          // console.log(list, '///////')
          this.propertyList = list
          this.getCheckedData()
        }
      })
    },
    createPropertyVal(data) {
      this.dialogVisiblePropertyValue = true
      this.propertyValue.propertyId = data.id
    },
    addPropertyVal() {
      PropertyValueCreate(this.propertyValue).then(res => {
        if (res.data.success) {
          this.dialogVisiblePropertyValue = false
          this.propertyValue.value = ''
          this.getProperty()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    },
    switchBtn(val, i) {
      // console.log(val, i)
      val.isSwitch = !val.isSwitch;
      if (val.isSwitch) {
        // this.getPropertyValueAll(val);
        // this.getAuditPassDetailBySup(val.searchData);
      }
    },
    getPropertyValueAll(item) {
      PropertyValueGetAll({PropertyId: item.id}).then(res => {
        if (res.data.success) {
          let list = res.data.result.items || []
          list.forEach(item => {
            item.isCheck = false
          })
          let id = item.id;
          let index = this.propertyList.findIndex((item) => {
            return item.id === id;
          });
          this.$set(this.propertyList[index], 'propertyValueList', list)
          this.getCheckedData()
          // this.propertyValueList = res.data.result.items
          // console.log(this.propertyList, '\\\\\\\\\/')
        }
      })
    },
    getCheckedData() {
      for (let i=0; i<this.propertyList.length; i++) {
        for (let j=0; j<this.checkList.length; j++) {
          if (this.checkList[j].id === this.propertyList[i].id) {
            this.propertyList[i].checkedCities = this.checkList[j].checkedCities
            //重新设置选中数据
            if (this.propertyList[i].checkedCities.length) {
              // 判断是否全选
              if (this.propertyList[i].checkedCities.length === this.propertyList[i].items.length) {
                this.propertyList[i].checkAll = true
                this.propertyList[i].isIndeterminate = false
              } else {
                this.propertyList[i].checkAll = false
                this.propertyList[i].isIndeterminate = true
              }
              this.propertyList[i].checkedCities.forEach(item => {
                let findTargIndex = this.propertyList[i].items.findIndex(i => {
                  return i.id === item
                })
                if (findTargIndex > -1) {
                  this.$set(this.propertyList[i].items[findTargIndex], 'isCheck', true)
                }
              })
            }
          }
        }
      }
    },
    submitProperty() {
      let list = this.propertyList.filter(item => {
        return item.checkAll || item.isIndeterminate
      })
      let arr = []
      list.forEach(item => {
        item.items.forEach(val => {
          if (val.isCheck) {
            arr.push({
              propertyId: item.id,
              propertyName: item.name,
              propertyValueId: val.id,
              propertyValueString: val.name
            })
          }
        })
      })
      // console.log(list, '11111')
      // console.log(arr, '2222')
      let data = {
        propertyGroupId: this.propertyGroupId,
        items: arr
      }
      UpdateProperties(data).then(res => {
        if (res.data.success) {
          this.dialogVisible1 = false
          this.getTableData()
        } else {
          this.$message.error(res.data.error.message)
        }
      })
    }

  }
}
</script>

<style scoped>
.maintain{
  padding: 0 20px;
}
.check-all{
  padding: 10px;
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
  background: #f5f5f5;
}
.switch {
  cursor: pointer;
  color: #499bfc;
}
</style>